import { Components } from '@mui/material/styles/components';
import { ControllerSelectColor } from '../../palette';
import theme from '../../provider/controllerBaseTheme';

export const SelectComponent: Components = {
  MuiSelect: {
    styleOverrides: {
      select: {
        padding: theme.spacing(1.25, 1),
        minHeight: 20,

        //
        // mason classes
        //
        '& .MasonSelectPlaceholder': {
          color: String(ControllerSelectColor.PlaceholderFg),
        },
      },
      icon: {
        transition: 'all .25s ease-out',
        transitionProperty: 'transform',
        transform: 'rotate(0deg)',
      },
      iconOpen: {
        transform: 'rotate(180deg)',
      },
    },
  },
  MuiNativeSelect: {
    styleOverrides: {
      select: {
        padding: theme.spacing(1.25, 4, 1.25, 1) + ' !important',
        height: '20px !important',

        //
        // mason classes
        //
        '& .MasonSelectPlaceholder': {
          color: String(ControllerSelectColor.PlaceholderFg),
        },
      },
      icon: {
        transition: 'all .25s ease-out',
        transitionProperty: 'transform',
        transform: 'rotate(0deg)',
      },
      iconOpen: {
        transform: 'rotate(180deg)',
      },
    },
  },
};
